__turbopack_context__.v({
  "isDisabled": "nextLink-module-scss-module__Ut4Jba__isDisabled",
});
